export const spaceChangeFilterValues = {
  true: 'spaceChangeRequested = true',
  false: 'spaceChangeRequested = false',
} as const;

export type SpaceChangeFilterValue =
  (typeof spaceChangeFilterValues)[keyof typeof spaceChangeFilterValues];
